import { Alert, AlertTitle, Box, Button, Card, CircularProgress, Divider, Fade, Typography, useTheme } from '@mui/material'
import { useAppDispatch, useAppSelector, BookingState, selectBooking, setRouteSelectedId } from "@/redux";
import { Fragment, useEffect, useState } from 'react'
import { Map, AdvancedMarker, Polyline, Pin } from '@vis.gl/react-google-maps';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/Routes';
import { DecodedRoute } from './RoutePreview.types';
import { useMap } from "@vis.gl/react-google-maps";
import RouteSelector from './RouteSelector';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useAuth } from '@/firebaseApp';
import { useApiIsLoaded } from '@vis.gl/react-google-maps';
import StripeHandler from '@/components/StripePayment'


export default function RoutePreview() {
  const navigate = useNavigate();
  const bookingDetails: BookingState = useAppSelector(selectBooking);
  const [mapCenter, _] = useState({ lat: 33.94, lng: -118.408 })
  const map = useMap();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const { user } = useAuth();
  const dispatch = useAppDispatch();
  const apiIsLoaded = useApiIsLoaded();

  useEffect(() => {
    if (
      !bookingDetails.loading &&
      bookingDetails.routes.length === 0
    ) {
      navigate(ROUTES.HOME, {
        replace: true,
      });
    }
  }, [
    bookingDetails.loading,
    bookingDetails.routes.length,
    navigate,
  ]);

  useEffect(() => {

    if (!map) return;

    const selectedRoute = bookingDetails.routes.find(
      r => r.id === bookingDetails.booking.routeSelectedId
    );


    if (!selectedRoute) return;

    const bounds = new google.maps.LatLngBounds();

    selectedRoute.path.forEach(p => bounds.extend(p));

    map.fitBounds(bounds, {
      top: 80,
      bottom: 80,
      left: 80,
      right: 80,
    });

  }, [
    map,
    bookingDetails.booking.routeSelectedId,
    bookingDetails.routes,
  ]);






  return (

    <Card
      sx={{
        bgcolor: 'background.paper',
        backdropFilter: 'blur(12px)',
        boxShadow: '0 25px 50px -12px rgb(0 0 0 / 0.25)',
        margin: '50px 0 50px 0',
        padding: '25px',
        maxWidth: {
          xs: '96%',   // phones
          md: '80%',    // tablets
          lg: '70%',    // large desktops
          xl: '70%',    // extra large desktops
        },
        mx: 'auto',     // centers the card,
        minHeight: '80vh'
      }}
    >
      {bookingDetails.loading ?
        (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%", // important
              minHeight: "300px", // fallback if parent has no height
            }}
          >
            <CircularProgress size="3rem" aria-label="Loading…" />
          </div>
        )
        :
        (
          <Fade
            in={!bookingDetails.loading}
            timeout={1000}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                columnGap: '3rem'
              }}
            >
              <Box
                sx={{
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.25)',
                }}
              ></Box>
              <Box
                sx={{
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.25)',
                }}
              >
                {apiIsLoaded ?
                  <Map
                    reuseMaps
                    mapId="eb0860a6fcaf54aa6e0763ef"
                    colorScheme={isDark ? "DARK" : "LIGHT"}   // 👈 THIS is what you want
                    defaultCenter={mapCenter}
                    defaultZoom={12}
                    style={{ width: "100%", height: "400px", borderRadius: "12px" }}
                  >
                    {bookingDetails.booking.routeSelectedId && bookingDetails.routes.map((route: DecodedRoute) => (
                      <Polyline
                        key={route.id}
                        path={route.path}
                        options={{
                          strokeColor:
                            bookingDetails.booking.routeSelectedId === route.id ? "#1976d2" : "#9e9e9e",
                          strokeOpacity: bookingDetails.booking.routeSelectedId === route.id ? 1 : 0.5,
                          strokeWeight: bookingDetails.booking.routeSelectedId === route.id ? 6 : 4,
                        }}
                        onClick={() => dispatch(setRouteSelectedId(route.id))}
                      />
                    ))}


                    {bookingDetails.booking.routeSelectedId && bookingDetails.routes.map((route: DecodedRoute) => (

                      // #378ADD
                      <Fragment key={route.id}>
                        <AdvancedMarker position={route.path[0]} >
                          <Pin background="#378ADD" borderColor={'#0a0064'}
                            glyphColor={'#0a0064'} />
                        </AdvancedMarker>

                        <AdvancedMarker position={route.path[route.path.length - 1]} />

                      </Fragment>
                    ))}

                  </Map> : <div>
                    loading</div>}
              </Box>
              <Box
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  overflow: "hidden",
                  padding: '2rem',
                  mb: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, p: 1.5 }}>
                  <FiberManualRecordIcon sx={{ color: "#378ADD", fontSize: '2rem', mt: 0.4, flexShrink: 0 }} />
                  <Box>
                    <Typography variant="caption" sx={{ color: "text.primary", textTransform: "uppercase", letterSpacing: "0.06em", display: "block" }}>
                      Pickup
                    </Typography>
                    <Typography variant="body2">{bookingDetails.booking.originPlace}</Typography>
                  </Box>
                </Box>

                <Divider />

                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, p: 1.5 }}>
                  <FiberManualRecordIcon sx={{ color: "#E24B4A", fontSize: '2rem', mt: 0.4, flexShrink: 0 }} />
                  <Box>
                    <Typography variant="caption" sx={{ color: "text.primary", textTransform: "uppercase", letterSpacing: "0.06em", display: "block" }}>
                      Drop-off
                    </Typography>
                    <Typography variant="body2">{bookingDetails.booking.destinationPlace}</Typography>
                  </Box>
                </Box>

                <RouteSelector
                  routes={bookingDetails.routes}
                  selectedId={bookingDetails.booking.routeSelectedId}
                  onSelect={(route) => dispatch(setRouteSelectedId(route.id))}
                />


              </Box>
              {
                user && bookingDetails.booking.routeSelectedId ?
                  <>
                    <StripeHandler />
                    <Alert
                      severity="info"
                      variant="outlined"
                      sx={{
                        mb: 2,
                        borderRadius: 2,
                        alignItems: "center",
                        fontSize: "0.9rem",
                      }}
                    >
                      <AlertTitle sx={{ fontWeight: 600 }}>
                        Notice
                      </AlertTitle>
                      Route Royale is currently undergoing final regulatory approvals. <br />
                      We will begin accepting bookings and processing payments once approvals are complete. <br />
                      Thank you for your patience.
                    </Alert>
                  </> :
                  (<Button
                    onClick={(_) => {
                      navigate(ROUTES.SIGN_IN,
                        {
                          state: {
                            rehydrate: true
                          }
                        }
                      )
                    }}

                    variant="outlined"
                    sx={{
                      borderColor: theme.palette.text.primary,
                      px: 4,
                      color: theme.palette.text.primary
                    }}
                  >
                    Sign-in
                  </Button>)
              }

            </Box>
          </Fade>
        )}

    </Card>
  )

}




